export const lang = {
	TITLE: 'Send as a gift',
	DESCRIPTION: 'After purchasing, you can choose who it will be sent to.',
	STARTS_WHEN_REDEEMED: 'The plan starts when the gift is redeemed.'
};
